import * as React from 'react'
import { Button, Well } from '@pushly/aqe/lib/components'
import { useState } from 'react'
import { Skeleton } from 'antd'
import EditPageAnalysisConfigDrawer from '@halo/components/edit-page-analysis-config-drawer/edit-page-analysis-config-drawer'
import { classnames } from '@halo/_utils/classnames'
import { IHydratedPageAnalysisConfig } from '@halo/interfaces/hydrated-page-analysis-config'
import Icon, { EditOutlined } from '@ant-design/icons'
import './style/page-analysis-config_details.scss'

export interface IPageAnalysisDetailsTabProps {
    hydratedPageAnalysisConfig: Partial<IHydratedPageAnalysisConfig>
    onUpdate: (update: IHydratedPageAnalysisConfig) => void
}

function PageAnalysisConfigDetailsTab(props: IPageAnalysisDetailsTabProps) {
    const [editPageAnalysisConfig, setEditPageAnalysisConfig] = useState(null)

    return (
        <React.Fragment>
            <Well
                title="Details"
                className="type-3 nested"
                actions={
                    <Button
                        size="small"
                        onClick={() => {
                            setEditPageAnalysisConfig(props.hydratedPageAnalysisConfig)
                        }}
                    >
                        <EditOutlined />
                        <span>Edit</span>
                    </Button>
                }
                hideFooter={true}
            >
                <Skeleton loading={!props.hydratedPageAnalysisConfig} active={true} title={false}>
                    <Well mode="ghost" hideHeader={true} hideFooter={true}>
                        {props.hydratedPageAnalysisConfig && (
                            <>
                                <div className={classnames('form-layout-row')}>
                                    <div className={classnames('form-layout-row-label')}>Name</div>
                                    <div className={classnames('form-layout-row-value')}>
                                        {props.hydratedPageAnalysisConfig.name}
                                    </div>
                                </div>

                                <div className={classnames('form-layout-row')}>
                                    <div className={classnames('form-layout-row-label')}>Extends</div>
                                    <div className={classnames('form-layout-row-value')}>
                                        {props.hydratedPageAnalysisConfig.parent_name}
                                    </div>
                                </div>

                                <div className={classnames('form-layout-row')}>
                                    <div className={classnames('form-layout-row-label')}>Associated Domains</div>
                                    <div className={classnames('form-layout-row-value')}>
                                        {props.hydratedPageAnalysisConfig.associated_domains
                                            .map((ad) => ad.name)
                                            .join(', ')}
                                    </div>
                                </div>
                            </>
                        )}
                    </Well>
                </Skeleton>
            </Well>

            <EditPageAnalysisConfigDrawer
                pageAnalysisConfig={editPageAnalysisConfig}
                onClose={() => setEditPageAnalysisConfig(null)}
                onUpdate={(pageAnalysisConfig) => {
                    setEditPageAnalysisConfig(null)
                    props.onUpdate(pageAnalysisConfig)
                }}
            />
        </React.Fragment>
    )
}

export default PageAnalysisConfigDetailsTab
